import h from "trader-hyperscript";
import { Field } from "trader.ts/ui.forms";

export function wrapFieldWithLabel<T>(s: string, f: Field<T>): Field<T> {
  return {
    ...f,
    render: () => (
      <label for="">
        <div className="label-text">{s}</div>
        {f.render()}
      </label>
    ),
  };
}
